import React from 'react';

//import component
import {Banner, HouseList} from '../components';

const Home = () => {
  return <div className="min-h-[1800px]">
    <Banner/>
    <HouseList/>
  </div>;
};

export default Home;
